import React, { Component } from 'react';
import { Table, Row, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import { inject, observer } from "mobx-react";
import { data5_3 } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import TableText from "../../TableText";
import ExportExcel from "@/method/components/ExportExcel"
const { TextArea } = Input;
const { MonthPicker } = DatePicker;


function numChange(text = 0) {

    let html = Number(text || '0') < 0 ?
        <span style={{ color: "red" }}>
            ({Math.abs(Number(text || "0")).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
        </span>
        :
        Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return html;

}

@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false
        }
    }


    componentDidMount() {
        this.getTable5_3(this.state.date);
    }

    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.setState({ data });
    }

    // 获取表格5_3的内容
    getTable5_3 = (date) => {
        const dataBegin = JSON.stringify(data5_3);
        let data = JSON.parse(dataBegin);

        fetch(`/_5_3_all?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.dataNow && x.data.dataNow.length > 0) {
                data = x.data.dataNow;
            }
            if (x.data.datalast && x.data.datalast.length > 0) {
                let datalast = x.data.datalast;
                const listName = ['strategy', 'action_plan', 'target', 'deadline', 'action_by'];
                data.forEach((item, i) => {
                    listName.forEach(name => {
                        data[i]['next_' + name] = data[i]['next_' + name] ? data[i]['next_' + name] : datalast[i]['third_' + name];
                        data[i]['third_' + name] = data[i]['third_' + name] ? data[i]['third_' + name] : datalast[i]['fourth_' + name];
                    });
                });
            }
            this.setState({
                loading: false,
                data
            }, () => {
                this.onChange('next_strategy', data[0].next_strategy, 0);
            });
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map((x, i) => ({ ...x, year, month, }));
        // if (!data.every(x => x.name)) {
        //     message.error('名称不能为空，请到3-1-1设置名称！');
        //     return
        // }
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_5_3', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getTable5_3(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table5_3', 1.5, '5.30', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const { data, print, date } = this.state;
        const width = document.body.offsetWidth - 3150 > 300 ? document.body.offsetWidth - 3150 : 300;
        const noInputData = [13, 14, 15, 16];
        const columns = [{
            title: 'Outlets 餐厅',
            dataIndex: 'outlets',
            key: 'outlets',
            align: "center",
            fixed: !print && "left",
            width,
            render: (text, record, index) => {
                return (
                    <div>
                        {text}
                    </div>
                )
            }
        }, {
            title: 'Next Month 下个月',
            width: 900,
            children: [{
                title: <div>Strategy <br />策略</div>,
                dataIndex: 'next_strategy',
                key: 'next_strategy',
                align: "center",
                width: 200,
                render: (text, record, index) => {
                    if (print) return text;
                    return (
                        <div className="table-padding table-color-number">
                            <TextArea
                                className="input-width"
                                autosize={{ minRows: 3, maxRows: 6 }}
                                defaultValue={text}
                                onBlur={(e) => {
                                    let value = e.target.value || "";
                                    this.onChange('next_strategy', value, index)
                                }}

                            />
                        </div>
                    )
                }
            }, {
                title: <div>Action Plan & F&B Promotion Plan <br />行动方案及餐饮促销计划</div>,
                dataIndex: 'next_action_plan',
                key: 'next_action_plan',
                align: "center",
                width: 400,
                render: (text, record, index) => {
                    if (print) return text;
                    return (
                        <div className="table-padding table-color-number">
                            <TextArea
                                className="input-width"
                                autosize={{ minRows: 3, maxRows: 6 }}
                                defaultValue={text}
                                onBlur={(e) => {
                                    let value = e.target.value || "";
                                    this.onChange('next_action_plan', value, index)
                                }}

                            />
                        </div>
                    )

                }
            }, {
                title: <div>Target <br />目标</div>,
                dataIndex: 'next_target',
                key: 'next_target',
                align: "center",
                width: 200,
                render: (text, record, index) => {
                    if (print) return text;
                    return (
                        <div className="table-padding table-color-number">
                            <TextArea
                                className="input-width"
                                autosize={{ minRows: 3, maxRows: 6 }}
                                defaultValue={text}
                                onBlur={(e) => {
                                    let value = e.target.value || "";
                                    this.onChange('next_target', value, index)
                                }}

                            />
                        </div>
                    )
                }
            }, {
                title: <div>Deadline<br /> 时间限定</div>,
                dataIndex: 'next_deadline',
                key: 'next_deadline',
                align: "center",
                width: 200,
                render: (text, record, index) => {
                    if (print) return text;
                    return (
                        <div className="table-padding table-color-number">
                            <TextArea
                                className="input-width"
                                autosize={{ minRows: 3, maxRows: 6 }}
                                defaultValue={text}
                                onBlur={(e) => {
                                    let value = e.target.value || "";
                                    this.onChange('next_deadline', value, index)
                                }}

                            />
                        </div>
                    )
                }
            }, {
                title: <div>Action By <br /> 执行者</div>,
                dataIndex: 'next_action_by',
                key: 'next_action_by',
                align: "center",
                width: 200,
                render: (text, record, index) => {
                    if (print) return text;
                    if (!noInputData.includes(index)) {
                        return (
                            <div className="table-padding table-color-number">
                                <TextArea
                                    autosize={{ minRows: 3, maxRows: 6 }}
                                    className="table_numInput"
                                    defaultValue={text}
                                    onBlur={(e) => {
                                        let value = e.target.value || "";
                                        this.onChange('next_action_by', value, index)
                                    }}

                                />
                            </div>
                        )
                    } else {
                        return (
                            <div className={`table-padding ${index == 13 || index == 16 ? 'table-color-footer' : ''} `}>
                                {numChange(text)}
                            </div>
                        )
                    }

                }
            },]
        }, {
            title: '3rd Month 第三个月',
            width: 900,
            children: [{
                title: <div>Strategy <br />策略</div>,
                dataIndex: 'third_strategy',
                key: 'third_strategy',
                align: "center",
                width: 200,
                render: (text, record, index) => {
                    if (print) return text;
                    return (
                        <div className="table-padding table-color-number">
                            <TextArea
                                className="input-width"
                                autosize={{ minRows: 3, maxRows: 6 }}
                                defaultValue={text}
                                onBlur={(e) => {
                                    let value = e.target.value || "";
                                    this.onChange('third_strategy', value, index)
                                }}

                            />
                        </div>
                    )
                }
            }, {
                title: <div>Action Plan & F&B Promotion Plan <br />行动方案及餐饮促销计划</div>,
                dataIndex: 'third_action_plan',
                key: 'third_action_plan',
                align: "center",
                width: 400,
                render: (text, record, index) => {
                    if (print) return text;
                    return (
                        <div className="table-padding table-color-number">
                            <TextArea
                                className="input-width"
                                autosize={{ minRows: 3, maxRows: 6 }}
                                defaultValue={text}
                                onBlur={(e) => {
                                    let value = e.target.value || "";
                                    this.onChange('third_action_plan', value, index)
                                }}

                            />
                        </div>
                    )
                }
            }, {
                title: <div>Target <br />目标</div>,
                dataIndex: 'third_target',
                key: 'third_target',
                align: "center",
                width: 200,
                render: (text, record, index) => {
                    if (print) {
                        return <TableText data={{ text, index, type: "text", onChange: this.onChange }} />
                    }
                    return (
                        <div className="table-padding table-color-number">
                            <TextArea
                                className="input-width"
                                autosize={{ minRows: 3, maxRows: 6 }}
                                defaultValue={text}
                                onBlur={(e) => {
                                    let value = e.target.value || "";
                                    this.onChange('third_target', value, index)
                                }}

                            />
                        </div>
                    )
                }
            }, {
                title: <div>Deadline<br /> 时间限定</div>,
                dataIndex: 'third_deadline',
                key: 'third_deadline',
                align: "center",
                width: 200,
                render: (text, record, index) => {
                    if (print) {
                        return <TableText data={{ text, index, type: "text", onChange: this.onChange }} />
                    }
                    return (
                        <div className="table-padding table-color-number">
                            <TextArea
                                className="input-width"
                                autosize={{ minRows: 3, maxRows: 6 }}
                                defaultValue={text}
                                onBlur={(e) => {
                                    let value = e.target.value || "";
                                    this.onChange('third_deadline', value, index)
                                }}

                            />
                        </div>
                    )
                }
            }, {
                title: <div>Action By <br /> 执行者</div>,
                dataIndex: 'third_action_by',
                key: 'third_action_by',
                align: "center",
                width: 200,
                render: (text, record, index) => {
                    if (print) {
                        return <TableText data={{ text, index, type: "text", onChange: this.onChange }} />
                    }
                    return (
                        <div className="table-padding table-color-number">
                            <TextArea
                                className="input-width"
                                autosize={{ minRows: 3, maxRows: 6 }}
                                defaultValue={text}
                                onBlur={(e) => {
                                    let value = e.target.value || "";
                                    this.onChange('third_action_by', value, index)
                                }}

                            />
                        </div>
                    )
                }
            },]
        }, {
            title: '4th Month 第四个月',
            width: 900,
            children: [{
                title: <div>Strategy <br />策略</div>,
                dataIndex: 'fourth_strategy',
                key: 'fourth_strategy',
                align: "center",
                width: 200,
                render: (text, record, index) => {
                    if (print) {
                        return <TableText data={{ text, index, type: "text", onChange: this.onChange }} />
                    }
                    return (
                        <div className="table-padding table-color-number">
                            <TextArea
                                className="input-width"
                                autosize={{ minRows: 3, maxRows: 6 }}
                                defaultValue={text}
                                onBlur={(e) => {
                                    let value = e.target.value || "";
                                    this.onChange('fourth_strategy', value, index)
                                }}

                            />
                        </div>
                    )
                }
            }, {
                title: <div>Action Plan & F&B Promotion Plan <br />行动方案及餐饮促销计划</div>,
                dataIndex: 'fourth_action_plan',
                key: 'fourth_action_plan',
                align: "center",
                width: 400,
                render: (text, record, index) => {
                    if (print) {
                        return <TableText data={{ text, index, type: "text", onChange: this.onChange }} />
                    }
                    return (
                        <div className="table-padding table-color-number">
                            <TextArea
                                className="input-width"
                                autosize={{ minRows: 3, maxRows: 6 }}
                                defaultValue={text}
                                onBlur={(e) => {
                                    let value = e.target.value || "";
                                    this.onChange('fourth_action_plan', value, index)
                                }}

                            />
                        </div>
                    )
                }
            }, {
                title: <div>Target <br />目标</div>,
                dataIndex: 'fourth_target',
                key: 'fourth_target',
                align: "center",
                width: 200,
                render: (text, record, index) => {
                    if (print) {
                        return <TableText data={{ text, index, type: "text", onChange: this.onChange }} />
                    }
                    return (
                        <div className="table-padding table-color-number">
                            <TextArea
                                className="input-width"
                                autosize={{ minRows: 3, maxRows: 6 }}
                                defaultValue={text}
                                onBlur={(e) => {
                                    let value = e.target.value || "";
                                    this.onChange('fourth_target', value, index)
                                }}

                            />
                        </div>
                    )
                }
            }, {
                title: <div>Deadline<br /> 时间限定</div>,
                dataIndex: 'fourth_deadline',
                key: 'fourth_deadline',
                align: "center",
                width: 200,
                render: (text, record, index) => {
                    if (print) {
                        return <TableText data={{ text, index, type: "text", onChange: this.onChange }} />
                    }
                    return (
                        <div className="table-padding table-color-number">
                            <TextArea
                                className="input-width"
                                autosize={{ minRows: 3, maxRows: 6 }}
                                defaultValue={text}
                                onBlur={(e) => {
                                    let value = e.target.value || "";
                                    this.onChange('fourth_deadline', value, index)
                                }}

                            />
                        </div>
                    )
                }
            }, {
                title: <div>Action By <br /> 执行者</div>,
                dataIndex: 'fourth_action_by',
                key: 'fourth_action_by',
                align: "center",
                width: 200,
                render: (text, record, index) => {
                    if (print) {
                        return <TableText data={{ text, index, type: "text", onChange: this.onChange }} />
                    }
                    return (
                        <div className="table-padding table-color-number">
                            <TextArea
                                className="input-width"
                                autosize={{ minRows: 3, maxRows: 6 }}
                                defaultValue={text}
                                onBlur={(e) => {
                                    let value = e.target.value || "";
                                    this.onChange('fourth_action_by', value, index)
                                }}

                            />
                        </div>
                    )
                }
            },]
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table5_3" style={{ width: this.state.print ? 3900 : 'auto' }}>
                        <Row>5.3 F&B 3 Month Rolling Action Plan By Outlets 三个月按照餐厅细分的滚动行动计划</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getTable5_3(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            id="export5_3_1"
                            pagination={false}
                            className="content"
                            style={{ width: this.state.print ? 3850 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 3850, y: 500 }}
                            rowKey={(record, index) => index}
                        />
                    </Row>

                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={() => {

                                this.setState({ print: true, loading: true }, () => {
                                    ExportExcel({
                                        id: "export5_3_1",
                                        date,
                                        name: "5.3 F&B 3 Month Rolling Action Plan By Outlets 三个月按照餐厅细分的滚动行动计划"
                                    });
                                    this.setState({ print: false, loading: false });
                                });

                            }}
                            loading={this.state.print}
                        >导出Excel</Button>
                        <Auth loading={this.state.loading} auth="edit_5_3">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Auth>
                    </Row>


                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-3/5_3.js